const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  description: (lambdaParameter, value) =>
    `${lambdaParameter}.Description.Contains("${value}")`,
  filterFileId: () => null,
  fileId: (lambdaParameter, value, otherValues) =>
    otherValues.filterFileId === false
      ? null
      : `${lambdaParameter}.EngineMediaFiles.Any(fle=>fle.Id==${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
